<template>
  <a-row class="content-fix" type="flex">
    <spinner v-if="loading" />

    <a-col v-show="!loading" class="height100 flex-1" style="padding-top: 30px">
      <span slot="tab"> <a-icon type="project" />Содержимое </span>

      <!-- lang tabs -->
      <a-row align="middle" class="flex-baseline sm-mb">
        <a-col :span="3" class="form_title"> Язык: </a-col>

        <a-col :span="12">
          <!-- lang translit tabs -->
          <a-row align="middle" class="flex-baseline flex-wrap">
            <lang-tabs v-model="langTab" class="mb-1x" />
            <a-button v-if="langTab === 'oz'" @click.stop="translitAction">
              Перевести копию на
              {{ langTab === "uz" ? "кирилицу" : "латиницу" }}
            </a-button>
          </a-row>
        </a-col>
      </a-row>

      <!-- title -->
      <a-row
        :class="{ 'form-group--error': emptyTitle }"
        align="middle"
        class="flex-baseline"
      >
        <a-col :span="3" class="sm-mb" />
        <a-col :span="12" class="sm-mb">
          <div class="form_field">
            <div class="deputy_image">
              <img :src="photo" alt="" />
            </div>
            <a-button
              style="font-size: 13px"
              type="primary"
              @click="uploadFile"
            >
              <a-icon style="font-size: 16px" type="upload" /> Upload Image
            </a-button>

            <span v-if="!photo" style="padding-left: 8px">
              Картинка не выбрана
            </span>

            <input
              ref="fileInput"
              class="UploadhideInput"
              type="file"
              accept="image/jpg, image/jpeg, image/png, image/svg"
              @change="handleFile"
            />
          </div>
        </a-col>
      </a-row>

      <a-row
        :class="{ 'form-group--error': emptyTitle }"
        align="middle"
        class="flex-baseline"
      >
        <a-col :span="3" class="form_title">
          <label>Ф.И.О</label>
        </a-col>
        <a-col :span="12" class="sm-mb">
          <a-input
            v-model="form.full_name[langTab]"
            class="form_title-input"
            :placeholder="$t('FormFirstNamePlace')"
          />
        </a-col>
      </a-row>

      <a-row
        :class="{ 'form-group--error': emptyTitle }"
        align="middle"
        class="flex-baseline"
      >
        <a-col :span="3" class="form_title">
          <label>Деятельность</label>
        </a-col>
        <a-col :span="12" class="sm-mb">
          <a-input
            v-model="form.activity[langTab]"
            class="form_title-input"
            placeholder="Введите деятельность"
          />
        </a-col>
      </a-row>

      <a-row
        :class="{ 'form-group--error': emptyTitle }"
        align="middle"
        class="flex-baseline"
      >
        <a-col :span="3" class="form_title">
          <label>Номер телефона</label>
        </a-col>
        <a-col :span="12" class="sm-mb">
          <a-input
            placeholder="Введите номер телефона"
            name="phone"
            type="tel"
          />
          <!--<a-input
            v-model="form.phone_number"
            v-mask="'+### (##) ###-##-##'"
            placeholder="Введите номер телефона"
            name="phone"
            type="tel"
          />-->
        </a-col>
      </a-row>

      <a-row
        :class="{ 'form-group--error': emptyTitle }"
        align="middle"
        class="flex-baseline"
      >
        <a-col :span="3" class="form_title">
          <label>Email</label>
        </a-col>
        <a-col :span="12" class="sm-mb">
          <a-input
            v-model="form.email"
            required
            :placeholder="$t('EnterEmail')"
          />
        </a-col>
      </a-row>

      <a-row align="middle" class="flex-baseline">
        <a-col :span="3" class="form_title"> Позиция: </a-col>
        <a-col :span="2" class="sm-mb">
          <a-input
            v-model="form.order"
            type="number"
            name="position"
            placeholder="Введите позицию"
          />
        </a-col>
      </a-row>

      <a-row style="margin-top: 15px">
        <a-col :span="3" class="form_title"> Статус: </a-col>
        <a-switch v-model="form.is_active" />
      </a-row>

      <!-- editor -->
      <a-row style="margin-top: 25px" type="flex">
        <a-col :span="3" class="form_title"> Биография: </a-col>
        <a-col v-show="langTab === 'oz'" :span="20">
          <editor
            :value="form.description.oz"
            :initial-value="form.description.oz"
            :init="{
              ...tinymce.default.props,
              setup: (editor) => {
                editor.ui.registry.addButton('spoiler-btn', {
                  icon: 'comment-add',
                  tooltip: 'Спойлер',
                  onAction: () => {
                    spoiler.modalVisibility = editor
                    spoilerHandler()
                  }
                })
                editor.ui.registry.addButton('storage-btn', {
                  icon: 'non-breaking',
                  tooltip: 'Хранилище изображений',
                  onAction: () => {
                    openStoreModal()
                    editorInstance = editor
                  }
                })
              }
            }"
            @input="form.description.oz = editorChangeHandler(arguments[0])"
          />
        </a-col>
        <a-col v-show="langTab === 'uz'" :span="20">
          <editor
            :value="form.description.uz"
            :initial-value="form.description.uz"
            :init="{
              ...tinymce.default.props,
              setup: (editor) => {
                editor.ui.registry.addButton('spoiler-btn', {
                  icon: 'comment-add',
                  tooltip: 'Спойлер',
                  onAction: () => {
                    spoiler.modalVisibility = editor
                    spoilerHandler()
                  }
                })
                editor.ui.registry.addButton('storage-btn', {
                  icon: 'non-breaking',
                  tooltip: 'Хранилище изображений',
                  onAction: () => {
                    openStoreModal()
                    editorInstance = editor
                  }
                })
              }
            }"
            @input="form.description.uz = editorChangeHandler(arguments[0])"
          />
        </a-col>
        <a-col v-show="langTab === 'ru'" :span="20">
          <editor
            :value="form.description.ru"
            :initial-value="form.description.ru"
            :init="{
              ...tinymce.default.props,
              setup: (editor) => {
                editor.ui.registry.addButton('spoiler-btn', {
                  icon: 'comment-add',
                  tooltip: 'Спойлер',
                  onAction: () => {
                    spoiler.modalVisibility = editor
                    spoilerHandler()
                  }
                })
                editor.ui.registry.addButton('storage-btn', {
                  icon: 'non-breaking',
                  tooltip: 'Хранилище изображений',
                  onAction: () => {
                    openStoreModal()
                    editorInstance = editor
                  }
                })
              }
            }"
            @input="form.description.ru = editorChangeHandler(arguments[0])"
          />
        </a-col>
        <a-col v-show="langTab === 'qr'" :span="20">
          <editor
            :value="form.description.qr"
            :initial-value="form.description.qr"
            :init="{
              ...tinymce.default.props,
              setup: (editor) => {
                editor.ui.registry.addButton('spoiler-btn', {
                  icon: 'comment-add',
                  tooltip: 'Спойлер',
                  onAction: () => {
                    spoiler.modalVisibility = editor
                    spoilerHandler()
                  }
                })
                editor.ui.registry.addButton('storage-btn', {
                  icon: 'non-breaking',
                  tooltip: 'Хранилище изображений',
                  onAction: () => {
                    openStoreModal()
                    editorInstance = editor
                  }
                })
              }
            }"
            @input="form.description.qr = editorChangeHandler(arguments[0])"
          />
        </a-col>
        <a-col v-show="langTab === 'en'" :span="20">
          <editor
            :value="form.description.en"
            :initial-value="form.description.en"
            :init="{
              ...tinymce.default.props,
              setup: (editor) => {
                editor.ui.registry.addButton('spoiler-btn', {
                  icon: 'comment-add',
                  tooltip: 'Спойлер',
                  onAction: () => {
                    spoiler.modalVisibility = editor
                    spoilerHandler()
                  }
                })
                editor.ui.registry.addButton('storage-btn', {
                  icon: 'non-breaking',
                  tooltip: 'Хранилище изображений',
                  onAction: () => {
                    openStoreModal()
                    editorInstance = editor
                  }
                })
              }
            }"
            @input="form.description.en = editorChangeHandler(arguments[0])"
          />
        </a-col>
      </a-row>

      <a-row class="form-buttons__action" style="margin-top: 20px" type="flex">
        <a-col :span="3" class="form_title" />
        <a-col>
          <a-button
            :disabled="pending"
            @click="
              $router.push({
                name: 'staffs'
              })
            "
          >
            <a-icon type="close" />{{ $t("Cancel") }}
          </a-button>

          <a-button
            :loading="pending"
            style="margin-left: 10px"
            type="primary"
            @click="updatePublicCouncil((saveback = false))"
          >
            <a-icon type="check" />
            {{ $t("Save") }}
          </a-button>
          <a-button
            :loading="pending"
            style="margin-left: 10px"
            type="primary"
            @click="updatePublicCouncil((saveback = true))"
          >
            <a-icon type="check" />
            {{ $t("SaveAndExit") }}
          </a-button>
        </a-col>
      </a-row>
    </a-col>

    <spoiler-modal
      v-show="!!spoiler.modalVisibility"
      v-model="spoiler"
      @ok="appendToEditor"
      @cancel="closeSpoilerModal"
    />
  </a-row>
</template>
<script>
import cloneDeep from "lodash/cloneDeep"
import spoiler from "@/mixins/spoiler.js"
const newsDefaultFields = () => ({
  full_name: {
    uz: "",
    oz: "",
    ru: "",
    en: "",
    qr: ""
  },
  description: {
    uz: "",
    oz: "",
    ru: "",
    en: "",
    qr: ""
  },
  activity: {
    uz: "",
    oz: "",
    ru: "",
    en: "",
    qr: ""
  },
  email: "",
  phone_number: "",
  is_active: false,
  photo: null,
  order: 1
})
export default {
  name: "StaffsDetail",
  components: {
    spoilerModal: () =>
      import("@/components/directory/modal-components/modal-spoiler"),
    editor: () => import("@tinymce/tinymce-vue")
  },
  mixins: [spoiler],
  data() {
    return {
      langTab: $langPrefix,
      form: { ...newsDefaultFields() },
      pending: false,
      loading: false,
      emptyTitle: false,
      modalVisible: false,
      photo: null
    }
  },
  computed: {
    getKey() {
      return this.langTab
    }
  },
  watch: {
    "$route.params.id": {
      handler(newVal, oldVal) {
        if (+oldVal !== +newVal) this.fetchData()
      },
      immediate: true
    }
  },
  methods: {
    uploadFile() {
      this.$refs.fileInput.click()
    },
    openStoreModal() {
      this.modalVisible = true
    },
    translitAction() {
      try {
        const from = this.langTab,
          to = this.langTab === "uz" ? "oz" : "uz",
          methodName = this.langTab === "uz" ? "toKirill" : "toLatin"

        if (this.form.title[from]) {
          this.form.title[to] = this[methodName](this.form.title[from])
        }
      } catch (error) {
        this.$sentry.captureMessage(error)
      }
    },
    async updatePublicCouncil(saveback) {
      if (this.pending) return
      this.pending = true
      try {
        let newData = cloneDeep(this.form)
        newData = {
          ...newData,
          full_name_ru: newData.full_name.ru,
          full_name_uz: newData.full_name.uz,
          full_name_oz: newData.full_name.oz,
          full_name_en: newData.full_name.en,
          full_name_qr: newData.full_name.qr,
          description_ru: newData.description.ru,
          description_uz: newData.description.uz,
          description_oz: newData.description.oz,
          description_en: newData.description.en,
          description_qr: newData.description.qr,
          activity_ru: newData.activity.ru,
          activity_uz: newData.activity.uz,
          activity_oz: newData.activity.oz,
          activity_en: newData.activity.en,
          activity_qr: newData.activity.qr
        }
        delete newData.full_name
        delete newData.activity
        delete newData.description

        if (typeof newData.photo === "string") {
          delete newData.photo
        }

        let f = new FormData()

        newData.photo && f.append("photo", newData.photo)

        Object.keys(newData).forEach((key) => {
          if (newData[key] === null) {
            newData[key] = ""
          }
          f.append(key, newData[key])
          // newData[key] && key !== "photo" && f.append(key, newData[key])
          // key === "is_active" && f.append(key, newData[key])
        })
        let res = await this.$api.patch(
          `/admin/structure/public-council/${this.form.id}/update/`,
          f
        )
        if (res.status >= 200 && saveback) {
          await this.$router.push({
            name: "public-council"
          })
        }
        this.pending = false
      } catch (error) {
        console.error(error)
        this.$sentry.captureMessage(error)
      }
    },
    fetchData() {
      this.loading = true
      if (isNaN(this.$route.params.id)) {
        this.loading = false
        return
      }
      this.$api
        .get(`/admin/structure/public-council/${this.$route.params.id}/update/`)
        .then(async (res) => {
          if (res && res.data) {
            const { ...data } = res.data
            this.form = {
              ...this.form,
              ...data,
              full_name: {
                oz: res.data.full_name_oz,
                uz: res.data.full_name_uz,
                ru: res.data.full_name_ru,
                en: res.data.full_name_en,
                qr: res.data.full_name_qr
              },
              activity: {
                oz: res.data.activity_oz,
                uz: res.data.activity_uz,
                ru: res.data.activity_ru,
                en: res.data.activity_en,
                qr: res.data.activity_qr
              },
              description: {
                oz: res.data.description_oz,
                uz: res.data.description_uz,
                ru: res.data.description_ru,
                en: res.data.description_en,
                qr: res.data.description_qr
              }
            }
            this.photo = this.form.photo
          }
          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
        })
    },
    handleFile(e) {
      this.photo = URL.createObjectURL(e.target.files[0])
      this.form.photo = e.target.files[0]
    }
  }
}
</script>
<style>
.ant-modal {
  max-height: 600px;
}
.scroll-container {
  padding: 20px 0px;
}
.form_field > .deputy_image {
  width: 70px;
  height: 70px;
  border: 1px solid grey;
  border-radius: 40px;
  overflow: hidden;
  display: inline;
  margin-right: 30px;
}
.form_field > .deputy_image > img {
  width: 100%;
  height: 100%;
}
.form_field {
  margin: 10px 0;
  height: 70px;
  padding: 0 30px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
</style>
